const displayConditionLogicalOperator = {
    AND : 0,

    OR : 1

};

angular.module('gw-um-j2js')
    .constant('displayConditionLogicalOperator', displayConditionLogicalOperator);